import { useState } from 'react'

// Same demo as the TutorWeights landing page: one student misconception,
// two tutor prompts, scored on the pedagogy rubric.
const VARIANTS = [
  {
    key: 'baseline',
    label: 'Baseline prompt',
    turns: [
      { role: 'student', text: 'I think 1/3 plus 1/4 is 2/7. Is that right?' },
      {
        role: 'tutor',
        text: 'Not quite. To add fractions you need a common denominator. 1/3 = 4/12 and 1/4 = 3/12, so 1/3 + 1/4 = 7/12.'
      },
      { role: 'student', text: 'ok so its 7/12. thanks' }
    ],
    scores: [
      { label: 'Scaffolding', value: 1.4 },
      { label: 'Misconception handling', value: 1.8 },
      { label: 'Over-answer control', value: 1.2 }
    ],
    overall: 47,
    verdict: 'Not ready',
    tags: ['gave_final_answer_too_early', 'over_answered', 'missed_misconception']
  },
  {
    key: 'guarded',
    label: 'Guarded prompt',
    turns: [
      { role: 'student', text: 'I think 1/3 plus 1/4 is 2/7. Is that right?' },
      {
        role: 'tutor',
        text: 'Good attempt. I can see why that feels right. Quick check: can you add 1/3 and 1/4 directly, or do the bottoms need to match first?'
      },
      { role: 'student', text: 'oh they need to match first... so like 4/12 and 3/12?' }
    ],
    scores: [
      { label: 'Scaffolding', value: 4.6 },
      { label: 'Misconception handling', value: 4.8 },
      { label: 'Over-answer control', value: 4.7 }
    ],
    overall: 95,
    verdict: 'Ready for pilot',
    tags: []
  }
]

const colorFor = (n, max) => {
  const r = n / max
  return r >= 0.8 ? '#35c98e' : r >= 0.6 ? '#f5b83d' : '#f0564f'
}

export default function TutorWeightsDemo() {
  const [active, setActive] = useState(0)
  const v = VARIANTS[active]
  const ready = v.verdict === 'Ready for pilot'

  return (
    <div className="tw-demo">
      <div className="tw-demo-head">
        <span className="tw-demo-title">TutorWeights</span>
        <span className="tw-demo-sub">Interactive demo. Synthetic student, no real data.</span>
      </div>

      <div className="tw-tabs" role="tablist">
        {VARIANTS.map((variant, i) => (
          <button
            key={variant.key}
            role="tab"
            aria-selected={i === active}
            className={`tw-tab ${i === active ? 'active' : ''}`}
            onClick={() => setActive(i)}
          >
            {variant.label}
          </button>
        ))}
      </div>

      <div className="tw-body">
        <div className="tw-transcript">
          {v.turns.map((t, i) => (
            <div className={`tw-turn ${t.role}`} key={i}>
              <div className="tw-who">{t.role === 'student' ? 'STUDENT' : 'AI TUTOR'}</div>
              <div className="tw-bubble">{t.text}</div>
            </div>
          ))}
        </div>

        <div className="tw-scores">
          <div className="tw-overall">
            <div className="tw-overall-value" style={{ color: colorFor(v.overall, 100) }}>
              {v.overall}
            </div>
            <div className="tw-overall-label">Launch readiness / 100</div>
            <span className={`tw-badge ${ready ? 'good' : 'bad'}`}>{v.verdict}</span>
          </div>

          {v.scores.map((s) => (
            <div className="tw-scorebar" key={s.label}>
              <div className="tw-name">{s.label}</div>
              <div className="tw-track">
                <div
                  className="tw-fill"
                  style={{ width: `${(s.value / 5) * 100}%`, background: colorFor(s.value, 5) }}
                />
              </div>
              <div className="tw-num">{s.value.toFixed(1)}</div>
            </div>
          ))}

          <div className="tw-tags">
            {v.tags.length > 0 ? (
              v.tags.map((t) => (
                <span className="tw-badge bad" key={t}>
                  {t.replace(/_/g, ' ')}
                </span>
              ))
            ) : (
              <span className="tw-badge good">no failure tags</span>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
